import { Post } from "../../../types/post";

export const REORDER_CATEGORY_POSTS = "REORDER_CATEGORY_POSTS";
export const REORDER_CATEGORY_POSTS_SUCCESS = "REORDER_CATEGORY_POSTS_SUCCESS";
export const REORDER_CATEGORY_POSTS_ERROR = "REORDER_CATEGORY_POSTS_ERROR";

export interface reorderCategoryPosts {
  type: typeof REORDER_CATEGORY_POSTS;
  payload: Post[];
}

export interface reorderCategoryPostsSuccess {
  type: typeof REORDER_CATEGORY_POSTS_SUCCESS;
  payload: Post[] | null;
}

export interface reorderCategoryPostsError {
  type: typeof REORDER_CATEGORY_POSTS_ERROR;
  payload: boolean | string;
}

export interface State {
  data: Post[] | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = reorderCategoryPosts | reorderCategoryPostsSuccess | reorderCategoryPostsError;
